import createMountUnmount from 'app/common/components/createMountUnmount';

export default createMountUnmount(
  () => {
    document.documentElement.classList.add('zapbook-refresh');
  },
  () => {
    document.documentElement.classList.remove('zapbook-refresh');
  }
);
